module.exports = __webpack_public_path__ + "static/media/parking-B.7f32237a.svg";